import { toggleAddFeedsSection, toggleAppsMoreSection, toggleCustomizationSection, toggleManageSection, togglePlanSection, toggleThemesSection, togglePublishSection } from "../actions/show_modal_Action";
import { toggleAddFeedsSection_D, toggleAppsMoreSection_D, toggleCustomizationSection_D, toggleManageSection_D, togglePlanSection_D, toggleThemesSection_D, togglePublishSection_D } from '../actions/showDisplayModalAction';
import store from "../store";
import { START_FEEDS_LOADER as START_FEEDS_LOADER_D } from "../reducers/keys";
import { PRODUCT_CANCELANCELLATION_STATUS, START_FEEDS_LOADER } from "../reducers/keys";


export const closePricingModal = (dispatch) => {
   const { showPlanSection, displayModalSection, userAccountData } = store.getState();
   if (showPlanSection.showPricing) {
      dispatch(togglePlanSection(false))
   }
   if (showPlanSection.showAppsMore) {
      dispatch(toggleAppsMoreSection(false))
   }
   if (showPlanSection.showAddFeed) {
      dispatch(toggleAddFeedsSection(false))
   }
   if (showPlanSection.showManageFeed) {
      dispatch(toggleManageSection(false))
   }
   if (showPlanSection.showThemes) {
      dispatch(toggleThemesSection(false))
   }
   if (showPlanSection.showCustomization) {
      dispatch(toggleCustomizationSection(false))
   }
   if (showPlanSection.showPublish) {
      dispatch(togglePublishSection(false))
   }
   if (displayModalSection.showPricingD) {
      dispatch(togglePlanSection_D(false))
   }
   if (displayModalSection.showAppsMoreD) {
      dispatch(toggleAppsMoreSection_D(false))
   }
   if (displayModalSection.showAddFeedD) {
      dispatch(toggleAddFeedsSection_D(false))
   }
   if (displayModalSection.showManageFeedD) {
      dispatch(toggleManageSection_D(false))
   }
   if (displayModalSection.showThemesD) {
      dispatch(toggleThemesSection_D(false))
   }
   if (displayModalSection.showCustomizationD) {
      dispatch(toggleCustomizationSection_D(false))
   }
   if (displayModalSection.showPublishD) {
      dispatch(togglePublishSection_D(false))
   }
   if(userAccountData.productCancellationStatus){
      dispatch({ type: PRODUCT_CANCELANCELLATION_STATUS, payload: false })
   }
}
